module.exports = __webpack_public_path__ + "img/testimonial-2.a49cc29.jpg";